import type { IconName } from '@designSystem/fondation/icons/iconsList'
import type { ContactAktoDTO } from '@/features/api/extranet/dto/shared'
import type { ContactAvecFavoris } from './useContactsFavorisStore'
import { TypeContactLibelle, type TypeContact } from '@/features/domaine/types/opco/shared/TypeContact'

export function useContactCardMapping() {
  function buildSubtitles(contact: ContactAktoDTO): SubtitleProps[] {
    const subtitles: SubtitleProps[] = []

    const poste = getPoste(contact)
    if (poste) {
      subtitles.push({ text: poste })
    }

    if (contact.email && contact.email.trim()) {
      subtitles.push({ text: contact.email, icon: 'email-tracking' })
    }

    if (contact.telephone && contact.telephone.trim()) {
      subtitles.push({ text: contact.telephone, icon: 'call-calling' })
    }

    return subtitles
  }

  function mapContactToCard(contact: ContactAvecFavoris): CardProps {
    return {
      avatar: getAvatar(contact),
      title: `${contact.nom ?? ''} ${contact.prenom ?? ''}`.trim(),
      subtitles: buildSubtitles(contact),
      showFavoris: contact.estFavoris,
      isFavoris: contact.estFavoris,
    }
  }

  return {
    buildSubtitles,
    mapContactToCard,
  }
}

function getPoste(contact: ContactAktoDTO): string | null {
  if (contact.fonction && contact.fonction.trim()) return contact.fonction
  const type = contact.typeContact as TypeContact
  if (type === 'ContactPilote' || type === 'ContactAef') {
    return TypeContactLibelle[type]
  }
  return null
}

function getAvatar(contact: ContactAvecFavoris): AvatarProps {
  if (contact.typeContact === 'CoordonneesRegion' || contact.typeContact === 'CoordonneesWeb') {
    return {
      type: 'icon',
      iconName: 'call-center' as IconName,
    }
  }

  return {
    type: 'name',
    name: `${contact.nom ?? ''} ${contact.prenom ?? ''}`.trim(),
  }
}
